module.exports = __webpack_public_path__ + "static/media/Можаев Борис Андреевич _Как слово наше отзовется _Свердловская обл.-4.png";